"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USE_CLASSES = void 0;
var USE_CLASSES = {
  default: 'uiPopover--default private-popover--default',
  longform: 'private-tooltip--longform',
  shepherd: 'private-popover--shepherd',
  tooltip: 'private-popover--tooltip',
  'tooltip-danger': 'private-popover--tooltip private-popover--tooltip-danger',
  unstyled: 'private-popover--unstyled'
};
exports.USE_CLASSES = USE_CLASSES;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3773/js/tooltip/utils/Use.js
// module id = 84
// module chunks = 0